import type { SessionInstructorAssignmentDTO } from "@/modules/classes/domain/contracts/sessions";

export type SessionInstructorFormRoles = {
  leadInstructorId: string;
  assistInstructorIds: string[];
};

/** Build API payload from lead + TA form fields */
export function instructorsFromLeadAssist(
  leadInstructorId: string,
  assistInstructorIds: string[],
): SessionInstructorAssignmentDTO[] {
  const lead = leadInstructorId.trim();
  if (!lead) return [];

  const assists = [...new Set(assistInstructorIds)]
    .filter((id) => id && id !== lead)
    .slice(0, 3)
    .map((instructorId) => ({
      instructorId,
      role: "assist" as const,
    }));

  return [{ instructorId: lead, role: "lead" }, ...assists];
}

/**
 * Load form defaults from session.instructors (preferred).
 * Falls back to legacy instructorIds only when instructors[] is missing.
 */
export function leadAssistFromSessionInstructors(
  instructors?:
    | Array<{ instructorId: string; role: "lead" | "assist" | string }>
    | null,
  fallbackIds?: string[] | null,
): SessionInstructorFormRoles {
  if (instructors != null && instructors.length > 0) {
    return {
      leadInstructorId:
        instructors.find((i) => i.role === "lead")?.instructorId ?? "",
      assistInstructorIds: instructors
        .filter((i) => i.role === "assist")
        .map((i) => i.instructorId),
    };
  }
  const ids = fallbackIds ?? [];
  return {
    leadInstructorId: ids[0] ?? "",
    assistInstructorIds: ids.slice(1, 4),
  };
}
